import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Link, Typography } from '@material-ui/core';
import { inIframe } from '../../helpers';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link
        target="_blank"
        rel="noopener noreferrer"
        color="inherit"
        href="http://guestranger.com/"
      >
        Guest Ranger LLC
      </Link>
      {' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  footer: {
    flexGrow: 1,
    overflow: 'auto',
    height: '70px',
    backgroundColor: '#fafafa',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
}));

export default function AppFooter() {
  const classes = useStyles();

  return (
    <>
      {!inIframe()
      && (
      <footer className={classes.footer}>
        <Box pb={0} pt={3}>
          <Copyright />
        </Box>
      </footer>
      )}
    </>
  );
}
